import { render, staticRenderFns } from "./QuantityItems.vue?vue&type=template&id=49311354&"
import script from "./QuantityItems.vue?vue&type=script&lang=ts&"
export * from "./QuantityItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports